import { defineMessages } from "@/i18n";
import en from "./en";

export const framesChartMessages = defineMessages("frames-chart", en);
